<template>
    <v-container fluid grid-list-md>
        <v-layout row wrap>
            <v-flex sm12>
                <v-card class="mt-2">
                    <v-card-title primary-title class="text-uppercase grey--text pt-2 pb-2">
                        Daily Breakdown for &nbsp;<b>{{ viewDateText }}</b>
                        <v-spacer></v-spacer>
                        <v-menu ref="viewDate" :close-on-content-click="false" v-model="viewDateShow" :return-value.sync="viewDate" lazy transition="scale-transition" offset-y full-width min-width="290px">
                            <v-btn slot="activator" large color="primary" style="min-width:200px;" depressed small class="ma-0">{{ viewDateText }}</v-btn>
                            <v-date-picker v-model="viewDate" color="primary" type="month" @input="onDateChange" no-title scrollable>
                            </v-date-picker>
                        </v-menu>
                    </v-card-title>
                    <v-divider></v-divider>
                    <v-card-text class="pa-0">
                        <!-- <div class="subheading">General</div> -->
                        <v-flex sm12 class="pa-0">
                            <v-progress-linear :indeterminate="true" class="pa-0 ma-0" v-if="isDailyBreakdownBusy"></v-progress-linear>
                            <apexcharts ref="monthBreakdown" width="100%" height="260" type="line" :options="monthGraphOptions" :series="monthGraphData"></apexcharts>
                        </v-flex>
                    </v-card-text>
                </v-card>
            </v-flex>
            <v-flex sm12 md6 lg9>
                <v-card>
                    <v-card-title primary-title class="text-uppercase grey--text">
                        Performance
                        <v-spacer></v-spacer>
                        {{ viewDateMonth }} Sales
                        <span class="pl-2 f-b black--text">{{ $format.currencyInt(currentSales) }}</span>
                    </v-card-title>
                    <v-divider></v-divider>
                    <v-card-text>
                        <div class="subheading">
                            TODAY
                            <div class="el-float-right">
                                <span class="f-s pr-1">Day Target</span>
                                <span class="f-s f-b">{{ $format.currencyInt(dailyTarget) }}</span>
                            </div>
                        </div>
                        <!-- <div class="grey--text text--darken-2">On track</div> -->
                        <v-layout row wrap class="f-m f-b">
                            <v-flex sm1 class="grey--text">Sales</v-flex>
                            <v-flex sm2 class="text-xs-right">{{ $format.currencyInt(dailySales) }}</v-flex>
                            <v-flex sm1>{{ dailySalesPerc }}%</v-flex>
                            <v-flex sm8>
                                <v-layout row>
                                    <v-flex sm1><v-icon small :color="dailySalesColor">{{ dailySalesIco }}</v-icon></v-flex>
                                    <v-flex sm11><v-progress-linear :indeterminate="isPerformanceBusy" :color="dailySalesColor" height="10" :value="dailySalesPerc" class="mt-1 mb-1"></v-progress-linear></v-flex>
                                </v-layout>
                            </v-flex>
                        </v-layout>
                        <v-layout row wrap class="f-m f-b">
                            <v-flex sm1 class="f-b grey--text">Orders</v-flex>
                            <v-flex sm2 class="text-xs-right">{{ $format.currencyInt(dailyOrders) }}</v-flex>
                            <v-flex sm1>{{ dailyOrdersPerc }}%</v-flex>
                            <v-flex sm8>
                                <v-layout row>
                                    <v-flex sm1><v-icon small :color="dailyOrdersColor">{{ dailyOrdersIco }}</v-icon></v-flex>
                                    <v-flex sm11><v-progress-linear :indeterminate="isPerformanceBusy" :color="dailyOrdersColor" height="10" :value="dailyOrdersPerc" class="mt-1 mb-1"></v-progress-linear></v-flex>
                                </v-layout>
                            </v-flex>
                        </v-layout>
                        <v-layout row wrap class="f-m f-b">
                            <v-flex sm1 class="f-b grey--text">Quotes</v-flex>
                            <v-flex sm2 class="text-xs-right">{{ $format.currencyInt(dailyQuotes) }}</v-flex>
                            <v-flex sm1>{{ dailyQuotesPerc }}%</v-flex>
                            <v-flex sm8>
                                <v-layout row>
                                    <v-flex sm1><v-icon small :color="dailyQuotesColor">{{ dailyQuotesIco }}</v-icon></v-flex>
                                    <v-flex sm11><v-progress-linear :indeterminate="isPerformanceBusy" :color="dailyQuotesColor" height="10" :value="dailyQuotesPerc" class="mt-1 mb-1"></v-progress-linear></v-flex>
                                </v-layout>
                            </v-flex>
                        </v-layout>
                    </v-card-text>
                    <v-divider></v-divider>
                    <v-card-text>
                        <div class="subheading">
                            {{ viewDateMonth.toUpperCase() }}
                            <div class="el-float-right">
                                <span class="f-s pr-1">Month Target</span>
                                <span class="f-s f-b">{{ $format.currencyInt(monthlyTarget) }}</span>
                            </div>
                        </div>
                        <!-- <div class="grey--text text--darken-2">On track</div> -->
                        <v-layout row wrap class="f-m f-b">
                            <v-flex sm1 class="grey--text">Sales</v-flex>
                            <v-flex sm2 class="text-xs-right">{{ $format.currencyInt(monthlySales) }}</v-flex>
                            <v-flex sm1>{{ monthlySalesPerc }}%</v-flex>
                            <v-flex sm8>
                                <v-layout row>
                                    <v-flex sm1><v-icon small :color="monthlySalesColor">{{ monthlySalesIco }}</v-icon></v-flex>
                                    <v-flex sm11><v-progress-linear :indeterminate="isPerformanceBusy" :color="monthlySalesColor" height="10" :value="monthlySalesPerc" class="mt-1 mb-1"></v-progress-linear></v-flex>
                                </v-layout>
                            </v-flex>
                        </v-layout>
                        <v-layout row wrap class="f-m f-b">
                            <v-flex sm1 class="f-b grey--text">Orders</v-flex>
                            <v-flex sm2 class="text-xs-right">{{ $format.currencyInt(monthlyOrders) }}</v-flex>
                            <v-flex sm1>{{ monthlyOrdersPerc }}%</v-flex>
                            <v-flex sm8>
                                <v-layout row>
                                    <v-flex sm1><v-icon small :color="monthlyOrdersColor">{{ monthlyOrdersIco }}</v-icon></v-flex>
                                    <v-flex sm11><v-progress-linear :indeterminate="isPerformanceBusy" :color="monthlyOrdersColor" height="10" :value="monthlyOrdersPerc" class="mt-1 mb-1"></v-progress-linear></v-flex>
                                </v-layout>
                            </v-flex>
                        </v-layout>
                        <v-layout row wrap class="f-m f-b">
                            <v-flex sm1 class="f-b grey--text">Quotes</v-flex>
                            <v-flex sm2 class="text-xs-right">{{ $format.currencyInt(monthlyQuotes) }}</v-flex>
                            <v-flex sm1>{{ monthlyQuotesPerc }}%</v-flex>
                            <v-flex sm8>
                                <v-layout row>
                                    <v-flex sm1><v-icon small :color="monthlyQuotesColor">{{ monthlyQuotesIco }}</v-icon></v-flex>
                                    <v-flex sm11><v-progress-linear :indeterminate="isPerformanceBusy" :color="monthlyQuotesColor" height="10" :value="monthlyQuotesPerc" class="mt-1 mb-1"></v-progress-linear></v-flex>
                                </v-layout>
                            </v-flex>
                        </v-layout>
                    </v-card-text>
                </v-card>
                <v-card class="mt-2">
                    <v-card-title primary-title class="text-uppercase grey--text">
                        Individual
                        <v-spacer></v-spacer>
                        <span>
                            <v-switch v-model="monthToggle" :label="monthToggleLabel" hide-details class="mt-0 pt-0 f-n"></v-switch>
                        </span>
                    </v-card-title>
                    <v-divider></v-divider>
                    <v-card-text>
                        <v-layout row wrap class="f-s f-b">
                            <v-flex xs12 sm6 md4 lg3 xl2 class="b-b pa-3" v-for="item in individualData" :key="item.User">
                                <div class="subheading">{{ item.User }}</div>
                                <div><span class="grey--text">{{ item.Department }}</span></div>
                                <div class="headline">{{ $format.currencyInt(item.Month[0].Amount) }} <span class="subheading">INV</span></div>
                                <v-layout row wrap>
                                    <v-flex sm12>
                                        <apexcharts width="100%" type="radialBar" :options="item.GraphOptions" :series="item.Graph.Month"></apexcharts>
                                    </v-flex>
                                </v-layout>
                                <v-layout row wrap>
                                    <v-flex sm3 class="pa-0 grey--text">&nbsp;</v-flex>
                                    <v-flex sm3 class="pa-0 grey--text text-xs-right">Qty</v-flex>
                                    <v-flex sm6 class="pa-0 grey--text text-xs-right pr-1">Amount</v-flex>
                                </v-layout>
                                <v-layout row wrap v-for="ds in item.Month" :key="ds._id">
                                    <v-flex sm3 class="pa-0 grey--text">{{ ds._id }}</v-flex>
                                    <v-flex sm3 class="pa-0 f-l f-b text-xs-right">{{ $format.int(ds.Qty) }}</v-flex>
                                    <v-flex sm6 class="pa-0 f-l f-b text-xs-right pr-1">{{ $format.currencyInt(ds.Amount) }}</v-flex>
                                </v-layout>
                                <!-- <v-layout row wrap>
                                    <v-flex sm3 class="pa-0 grey--text">Orders</v-flex>
                                    <v-flex sm3 class="pa-0 f-l f-b text-xs-right">0</v-flex>
                                    <v-flex sm6 class="pa-0 f-l f-b text-xs-right pr-1">R0</v-flex>
                                </v-layout>
                                <v-layout row wrap>
                                    <v-flex sm3 class="pa-0 grey--text">Quotes</v-flex>
                                    <v-flex sm3 class="pa-0 f-l f-b text-xs-right">0</v-flex>
                                    <v-flex sm6 class="pa-0 f-l f-b text-xs-right pr-1">R0</v-flex>
                                </v-layout> -->
                            </v-flex>
                        </v-layout>
                    </v-card-text>
                </v-card>
            </v-flex>
            <v-flex sm12 md6 lg3>
                <v-card>
                    <v-card-title primary-title class="text-uppercase grey--text">Events</v-card-title>
                    <v-divider></v-divider>
                    <v-card-text>
                        <div class="subheading">Birthdays</div>
                        <!-- <div class="grey--text text--darken-2">Hans Bleijs</div> -->
                        <div class="grey--text text--darken-2">-</div>
                    </v-card-text>
                    <v-divider></v-divider>
                    <v-card-text>
                        <div class="subheading">On Leave</div>
                        <!-- <div class="grey--text text--darken-2">Sibonelo Mbuthu</div> -->
                        <div class="grey--text text--darken-2">-</div>
                    </v-card-text>
                </v-card>
                <v-card class="mt-2">
                    <v-card-title primary-title class="text-uppercase grey--text">Factory Jobs</v-card-title>
                    <v-divider></v-divider>
                    <v-card-text>
                        <div class="subheading">In Progress</div>
                        <!-- <div class="grey--text text--darken-2">None</div> -->
                        <div class="grey--text text--darken-2">-</div>
                    </v-card-text>
                </v-card>
            </v-flex>
        </v-layout>
    </v-container>
</template>

<script>
import * as DF from 'date-fns';
import VueApexCharts from 'vue-apexcharts';
import Time from '../../util/Time';

export default {
    name: 'Dashboard',
    components: {
        apexcharts: VueApexCharts
        // CalendarView,
        // CalendarViewHeader
    },
    // mixins: [CalendarMathMixin],
    data() {
        return {
            title: 'Dashboard',
            viewDateShow: false,
            viewDate: Time.dateToDateString(new Date()),
            get viewDateText() {
                return DF.format(new Date(this.viewDate), 'MMMM yyyy');
            },
            get viewDateMonth() {
                return DF.format(new Date(this.viewDate), 'MMMM');
            },
            currentSales: 0,
            isPerformanceBusy: false,
            dailyTarget: 0,
            dailySales: 0,
            dailySalesPerc: 0,
            dailySalesIco: 'trending_down',
            dailySalesColor: 'grey darken-2',
            dailyOrders: 0,
            dailyOrdersPerc: 0,
            dailyOrdersIco: 'trending_down',
            dailyOrdersColor: 'grey darken-2',
            dailyQuotes: 0,
            dailyQuotesPerc: 0,
            dailyQuotesIco: 'trending_up',
            dailyQuotesColor: 'grey darken-1',
            monthlyTarget: 0,
            monthlySales: 0,
            monthlySalesPerc: 0,
            monthlySalesIco: 'trending_down',
            monthlySalesColor: 'grey darken-2',
            monthlyOrders: 0,
            monthlyOrdersPerc: 0,
            monthlyOrdersIco: 'trending_down',
            monthlyOrdersColor: 'grey darken-2',
            monthlyQuotes: 0,
            monthlyQuotesPerc: 0,
            monthlyQuotesIco: 'trending_up',
            monthlyQuotesColor: 'grey darken-1',
            monthToggle: false,
            monthToggleLabel: 'Entire Month',
            individualData: [],
            isIndividualBusy: false,
            // individualSeries: [], // [76, 67, 61],
            /* individualOptions: {
                plotOptions: {
                    radialBar: {
                        size: undefined,
                        inverseOrder: false,
                        offsetY: -10,
                        startAngle: 0,
                        endAngle: 360,
                        hollow: {
                            margin: 5,
                            size: '30%',
                            background: 'transparent',
                            image: undefined,
                        },
                        dataLabels: {
                            name: {
                                show: false,
                            },
                            value: {
                                show: false,
                            }
                        }
                    }
                },
                colors: ['grey darken-2', 'grey darken-2', 'grey darken-2'],
                labels: ['Sales', 'Orders', 'Quotes'],
                legend: { show: false }
            }, */
            isDailyBreakdownBusy: false,
            monthGraphOptions: {
                chart: {
                    toolbar: {
                        show: false
                    },
                    zoom: {
                        enabled: false
                    },
                },
                dataLabels: {
                    enabled: true
                },
                stroke: {
                    curve: 'smooth',
                    dashArray: [0, 0, 8],
                    width: [2, 5, 3]
                },
                xaxis: {
                    // type: 'datetime',
                    labels: { show: true },
                    axisTicks: { show: false }
                },
                yaxis: {
                    axisBorder: { show: true },
                    tickAmount: 3
                },
                grid: {
                    xaxis: {
                        min: 0,
                        lines: {
                            show: true,
                        }
                    },
                    yaxis: {
                        min: 0,
                        lines: {
                            show: true,
                        }
                    }
                },
                tooltip: {
                    x: {
                        formatter: this.monthTitleFormatDate.bind(this)
                    },
                    y: {
                        formatter: this.monthTitleFormatValue.bind(this)
                    }
                },
                // colors: ['#000', '#F00'],
                colors: ['rgba(0,50,100,0.3)', '#888', '#AAA'],
                legend: {
                    show: true
                },
                fill: {
                    opacity: 1,
                    type: 'solid'
                },
                markers: {
                    size: 5,
                    hover: {
                        size: 9
                    }
                },
            },
            monthGraphData: [{
                name: 'Target',
                data: []
            }, {
                name: 'Sales',
                data: []
            }, {
                name: 'Quotes',
                data: []
            }],
        };
    },
    mounted() {
        this.user = this.$ls.get('User');
        Object.defineProperty(this.user, 'has', { value: this.$has });
        this.ViewCompany = this.$ls.get('ViewCompany', {});
        this.blankInit();
        this.loadData();
    },
    methods: {
        onDateChange() {
            this.$refs.viewDate.save(this.viewDate);
            this.loadData();
        },
        blankInit() {
            const dataTarget = [];
            const dataSales = [];
            const dataOrders = [];
            const labels = [];
            const dt = new Date(`${this.viewDate.substr(0, 7)}-01`);
            const monthDays = DF.getDaysInMonth(dt);
            for (let d = 1; d <= monthDays; d++) {
                labels.push(`${d}.`);
                // dataTarget.push(Math.floor(Math.random() * 1000) + 10);
                dataTarget.push(1000);
                // dataSales.push(Math.floor(Math.random() * 800) + 10);
                // dataOrders.push(Math.floor(Math.random() * 500) + 10);
                dataSales.push(0);
                dataOrders.push(0);
            }
            this.monthGraphData[0].data = dataTarget;
            this.monthGraphData[1].data = dataSales;
            this.monthGraphData[2].data = dataOrders;
            // this.monthGraphOptions.xaxis.categories = labels;
            this.monthGraphOptions.labels = labels;
            // updateOptions | render ?
            this.$refs.monthBreakdown.updateSeries(this.monthGraphData);
            // this.$refs.monthBreakdown.refresh();
        },
        async loadData() {
            this.loadDailyBreakdown();
            this.loadPerformance();
            this.loadIndividual();
        },
        async loadDailyBreakdown() {
            try {
                this.isDailyBreakdownBusy = true;
                const response = await this.$http.post('/Dashboard/daily-breakdown', { C_Id: this.ViewCompany._id, Date: new Date(this.viewDate) });
                const data = response.data.d;
                const dataTarget = [];
                const dataSales = [];
                const dataOrders = [];
                const labels = [];
                const dt = new Date(`${this.viewDate.substr(0, 7)}-01`);
                const monthDays = DF.getDaysInMonth(dt);
                this.currentSales = 0;
                for (let d = 1; d <= monthDays; d++) {
                    labels.push(`${d}.`);
                    dataTarget.push(200000);
                    const sales = data.Invoices.find(o => o._id === d);
                    dataSales.push(sales ? ~~sales.Total : 0);
                    this.currentSales += sales ? sales.Total : 0;
                    const quotes = data.Quotes.find(o => o._id === d);
                    dataOrders.push(quotes ? ~~quotes.Total : 0);
                }
                this.monthGraphData[0].data = dataTarget;
                this.monthGraphData[1].data = dataSales;
                this.monthGraphData[2].data = dataOrders;
                this.monthGraphOptions.labels = labels;
                this.$refs.monthBreakdown.updateSeries(this.monthGraphData);
            }
            catch (err) {
                console.error(err);
                this.$alert({ type: 'error', title: 'Data Error', message: 'An error occurred fetching the data.' });
            }
            finally {
                this.isDailyBreakdownBusy = false;
            }
        },
        async loadPerformance() {
            try {
                this.isPerformanceBusy = true;
                const response = await this.$http.post('/Dashboard/performance', { C_Id: this.ViewCompany._id, Date: new Date(this.viewDate) });
                const data = response.data.d;
                // this.dailyTarget = 0;
                const dayI = data.Today.find(o => o.DOC === 'I');
                this.dailySales = dayI ? dayI.Total : 0;
                this.dailySalesPerc = 0;
                this.dailySalesIco = 'trending_down';
                this.dailySalesColor = 'grey darken-2';
                const dayO = data.Today.find(o => o.DOC === 'O');
                this.dailyOrders = dayO ? dayO.Total : 0;
                this.dailyOrdersPerc = 0;
                this.dailyOrdersIco = 'trending_down';
                this.dailyOrdersColor = 'grey darken-2';
                const dayQ = data.Today.find(o => o.DOC === 'Q');
                this.dailyQuotes = dayQ ? dayQ.Total : 0;
                this.dailyQuotesPerc = 0;
                this.dailyQuotesIco = 'trending_up';
                this.dailyQuotesColor = 'grey darken-1';
                const monI = data.Month.find(o => o.DOC === 'I');
                // this.monthlyTarget = 0;
                this.monthlySales = monI ? monI.Total : 0;
                this.monthlySalesPerc = 0;
                this.monthlySalesIco = 'trending_down';
                this.monthlySalesColor = 'grey darken-2';
                const monO = data.Month.find(o => o.DOC === 'O');
                this.monthlyOrders = monO ? monO.Total : 0;
                this.monthlyOrdersPerc = 0;
                this.monthlyOrdersIco = 'trending_down';
                this.monthlyOrdersColor = 'grey darken-2';
                const monQ = data.Month.find(o => o.DOC === 'Q');
                this.monthlyQuotes = monQ ? monQ.Total : 0;
                this.monthlyQuotesPerc = 0;
                this.monthlyQuotesIco = 'trending_up';
                this.monthlyQuotesColor = 'grey darken-1';
            }
            catch (err) {
                console.error(err);
                this.$alert({ type: 'error', title: 'Data Error', message: 'An error occurred fetching the data.' });
            }
            finally {
                this.isPerformanceBusy = false;
            }
        },
        async loadIndividual() {
            try {
                this.isIndividualBusy = true;
                const response = await this.$http.post('/Dashboard/individual', { C_Id: this.ViewCompany._id, Date: new Date(this.viewDate) });
                const data = response.data.d;
                this.individualData = data;
                data.forEach(o => {
                    o.GraphOptions = {
                        plotOptions: {
                            radialBar: {
                                size: undefined,
                                inverseOrder: false,
                                offsetY: -10,
                                startAngle: 0,
                                endAngle: 360,
                                hollow: {
                                    margin: 5,
                                    size: '30%',
                                    background: 'transparent',
                                    image: undefined,
                                },
                                dataLabels: {
                                    name: {
                                        show: false,
                                    },
                                    value: {
                                        show: false,
                                    }
                                }
                            }
                        },
                        colors: ['red darken-2', 'grey darken-2', 'grey darken-2'],
                        labels: ['Sales', 'Orders', 'Quotes'],
                        legend: { show: false }
                    };
                });
                /* const dataTarget = [];
                const dataSales = [];
                const dataOrders = [];
                const labels = [];
                const dt = new Date(`${this.viewDate.substr(0, 7)}-01`);
                const monthDays = DF.getDaysInMonth(dt);
                this.currentSales = 0;
                for (let d = 1; d <= monthDays; d++) {
                    labels.push(`${d}.`);
                    dataTarget.push(200000);
                    const sales = data.Invoices.find(o => o._id === d);
                    dataSales.push(sales ? ~~sales.Total : 0);
                    this.currentSales += sales ? sales.Total : 0;
                    const quotes = data.Quotes.find(o => o._id === d);
                    dataOrders.push(quotes ? ~~quotes.Total : 0);
                }
                this.monthGraphData[0].data = dataTarget;
                this.monthGraphData[1].data = dataSales;
                this.monthGraphData[2].data = dataOrders;
                this.monthGraphOptions.labels = labels;
                this.$refs.monthBreakdown.updateSeries(this.monthGraphData); */
            }
            catch (err) {
                console.error(err);
                this.$alert({ type: 'error', title: 'Data Error', message: 'An error occurred fetching the data.' });
            }
            finally {
                this.isIndividualBusy = false;
            }
        },
        monthTitleFormatDate(value) {
            const d = new Date(`${this.viewDate.substr(0, 7)}-${value}`);
            return DF.format(d, 'E, d MMMM yyyy');
        },
        monthTitleFormatValue(value) {
            return this.$format.currencyInt(value);
        }
    }
};
</script>



// WEBPACK FOOTER //
// src/components/Overview/Dashboard.vue